<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form" lazy-validation>
    <v-card :class="{ ['elevation-12']: $vuetify.breakpoint.smAndUp }">
      <v-card-title class="display-1">
        Passwort ändern
      </v-card-title>
      <v-card-text>
        <div class="pa-1 mb-2">
          <span
            v-if="errorsForField('non_field_errors').length"
            v-for="error in errorsForField('non_field_errors')"
            :key="error"
            class="red--text"
          >
            {{ error }}
          </span>
        </div>
        <input
          type="text"
          name="username"
          :value="username"
          autocomplete="username"
          style="display: none;"
        />
        <v-text-field
          v-model="value.old_password"
          :rules="[$rules.required]"
          :autofocus="$vuetify.breakpoint.smAndUp"
          :error-messages="errorsForField('old_password')"
          label="Aktuelles Passwort"
          type="password"
          autocomplete="current-password"
          box
        ></v-text-field>
        <v-text-field
          v-model="value.new_password"
          :rules="[$rules.required]"
          :error-messages="errorsForField('new_password')"
          label="Neues Passwort"
          type="password"
          autocomplete="new-password"
          box
        ></v-text-field>
        <v-text-field
          v-model="value.new_password_confirmation"
          :rules="[$rules.required]"
          :error-messages="errorsForField('new_password_confirmation')"
          label="Neues Passwort bestätigen"
          type="password"
          autocomplete="new-password"
          box
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          @click="cancel"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { getUsername } from '@/helpers/authentication';


export default {
  name: 'ChangePasswordForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    submitText: {
      type: String,
      default: () => 'speichern',
    },
  },
  data() {
    return {
      valid: true,
      username: getUsername(),
    };
  },
  watch: {
    'value.old_password': function changed() {
      delete this.errors.old_password;
    },
    'value.new_password': function changed() {
      delete this.errors.new_password;
    },
    'value.new_password_confirmation': function changed() {
      delete this.errors.new_password_confirmation;
    },
  },
  computed: {
    errorsForOldPassword() {
      return this.errorsForField('old_password');
    },
  },
  methods: {
    errorsForField(field) {
      return field in this.errors ? this.errors[field] : [];
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
    cancel() {
      this.$emit('cancel');
      this.$refs.form.reset();
    },
  },
};
</script>
